import type { UseFormReturn } from "react-hook-form";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { superRefinePhoneNumber } from "@/lib/helpers/phone-number-validation";

const clientPhonNumberSchema = z
  .object({
    currentPhoneNumber: z.string().min(6, "Invalid phone number"),
    newPhoneNumber: z.string().min(6, "Invalid phone number"),
  })
  .superRefine((arg, ctx) => {
    superRefinePhoneNumber({
      phoneNumber: arg.currentPhoneNumber,
      ctx,
      phoneNumberFieldName: "currentPhoneNumber",
    });
    superRefinePhoneNumber({
      phoneNumber: arg.newPhoneNumber,
      ctx,
      phoneNumberFieldName: "newPhoneNumber",
    });
  });

export type ChangePhoneNumberFormData = z.input<typeof clientPhonNumberSchema>;

export interface ChangePhoneNumberFormReturn
  extends UseFormReturn<ChangePhoneNumberFormData> {
  defaultValues: ChangePhoneNumberFormData;
}

const initialFormValues: ChangePhoneNumberFormData = {
  currentPhoneNumber: "",
  newPhoneNumber: "+65",
};

export const useChangePhoneNumberForm = (
  initialValues?: ChangePhoneNumberFormData,
): ChangePhoneNumberFormReturn => ({
  defaultValues: initialValues || initialFormValues,
  ...useForm<ChangePhoneNumberFormData>({
    mode: "onChange",
    defaultValues: initialValues,
    resolver: zodResolver(clientPhonNumberSchema),
  }),
});
